<form class="tw-w-fit tw-h-fit tw-mb-4" [formGroup]="formGroup">
  <p class="tw-w-fit tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary tw-mb-1">
    {{ label | translate }}
  </p>
  <div class="tw-w-fit tw-h-fit tw-flex tw-justify-center tw-items-center tw-gap-2 tw-mb-2">
    <p class="tw-w-fit tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary">
      {{ negative.label | translate }}
    </p>
    <div
      [ngClass]="formGroup.value[formControlName] == positive.value ? 'tw-bg-secondary' : 'tw-bg-secondary/50'"
      class="tw-w-fit tw-h-fit tw-relative tw-flex tw-items-center tw-cursor-pointer tw-bg-secondary tw-rounded-full tw-p-1"
      (click)="toggle()"
    >
      <div class="tw-w-11 tw-h-5 tw-transition-all tw-duration-300"></div>
      <div
        [ngClass]="formGroup.value[formControlName] == positive.value ? 'tw-bg-primary' : 'tw-bg-primary/70'"
        class="tw-w-5 tw-h-5 tw-rounded-full tw-dot tw-absolute tw-shadow-md tw-transition-transform tw-duration-300"
        [class.tw-translate-x-0]="formGroup.value[formControlName] != positive.value"
        [class.tw-translate-x-6]="formGroup.value[formControlName] == positive.value"
      ></div>
    </div>

    <p class="tw-w-fit tw-h-fit tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary">
      {{ positive.label | translate }}
    </p>
  </div>
  <div *ngIf="formGroup.get(formControlName).invalid && (formGroup.get(formControlName).touched || formGroup.get(formControlName).dirty)">
    <small *ngIf="formGroup.get(formControlName).errors['required']" class="tw-font-poppins tw-font-medium tw-text-xs tw-text-warning">{{ label | translate }} {{ "is-required" | translate }}</small>
  </div>
</form>
